import React, { useEffect, useState } from 'react'
import CertificateGenerator from '../../components/CertificateGenerator'
import { useParams } from 'react-router-dom';
import axios from 'axios';
import useErrorHandler from '../../hooks/useErrorHandler';
import { useDispatch, useSelector } from 'react-redux';
import { __hideLoader, __showLoader } from '../../Redux Store/Slices/loader';
import { certificatePublicUrl, certificateUrl, courseUrl } from '../../urls';
import moment from 'moment';
import NotFound from '../../NotFound';

const PublicCertificate = () => {
    const params = useParams();
    const id = params.id;
    const errorHandler = useErrorHandler();
    const dispatch = useDispatch();
    const { show } = useSelector(ctx => ctx.loader);

    const [data, setData] = useState({
        "courseEnrollmentId": "",
        "recipientName": "",
        "courseName": "",
        "issuedAt": "",
        tags: [],
        id: '',
        hrs: 0
    });
console.log(data)
    useEffect(() => {
        if (id) {
            dispatch(__showLoader("Public Certificate Loading..."));
            axios.get(certificatePublicUrl(id)).then(res => {
                console.log({ resdata: res.data.certificate });
                const data = res.data;
                const certificate = data.certificate;
                const courseEnrollment = certificate.courseEnrollment;
                setData({
                    courseEnrollmentId: courseEnrollment.id,
                    recipientName: certificate.recipientName,
                    courseName: certificate.courseName,
                    courseParentName: courseEnrollment.course.name,
                    issuedAt: moment(certificate.issuedAt).format("DD-MM-YYYY"),
                    tags: courseEnrollment.course.tags,
                    hrs: courseEnrollment.course.duration,
                    id: certificate.id,
                    type: certificate.type
                })
            }).catch(errorHandler).finally(() => {
                dispatch(__hideLoader())
            })
        }
    }, [id]);
    if (!show)
        return (
            <div>
                {data.courseEnrollmentId !== "" ? <CertificateGenerator data={data} showCopyButton /> : <NotFound/>}
            </div>
        )
}

export default PublicCertificate